<template>
  <div>
    <div class="grid-x grid-padding-x">
      <div class="cell small-12">
        <div class="bordered pad">
          <h1>
            Resources
            <router-link
              class="button float-right"
              to="/manage-resources"
              v-if="parseInt(userLevel, 10) === 1">Manage Resources</router-link>
          </h1>
        </div>
      </div>
    </div>
    <div class="grid-x grid-padding-x pad-top">
      <div class="cell small12">
        <div class="bordered pad">
          <ul>
            <li v-for="(resource, index) in resources" v-bind:key="index">
              <a :href="resource.uri" target="_blank">{{ resource.title }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../axios';

export default {
  name: 'Resources',
  computed: {
    authData() {
      return this.$store.getters.authData;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    userLevel() {
      return this.$store.getters.userLevel;
    },
    courseChosen() {
      return this.$store.getters.courseChosen;
    },
  },
  data() {
    return {
      resources: [],
    };
  },
  methods: {
    getResources() {
      axios.get(`/resources/getAll/${this.courseChosen}.json?auth=${this.authData.token}&user=${this.authData.userId}&cage=${this.authData.cage}&level=${this.userLevel}`)
        .then((response) => {
          this.resources = response.data.resources;
        });
    },
  },
  watch: {
    courseChosen() {
      this.resources = [];
      this.getResources();
    },
  },
  mounted() {
    this.getResources();
  },
};
</script>
